import { AxiosInstance } from 'axios'
import { useMutation, useQueryClient } from 'react-query'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

import { CrunchData } from '@dc-shared-web/hooks/api/document/types'

type SetUserFlagParams = {
  flag: string
}

const setUserFlag = async (
  apiClient: AxiosInstance,
  params: SetUserFlagParams
): Promise<void> => {
  await apiClient.postForm('/ajax/user-flags/add', {
    flag: params.flag,
  })
}

export const useSetUserFlag = () => {
  const apiClient = useAxiosContext()
  const queryClient = useQueryClient()

  return useMutation(
    (params: SetUserFlagParams) => setUserFlag(apiClient, params),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries<CrunchData>('Document')
      },
    }
  )
}
